import { createRouter, createWebHistory } from "vue-router";
import LoginView from "../views/LoginView.vue";
import CreateProject from "../views/CreateProject.vue";
import { getAuth } from "firebase/auth";
import { useCurrentUser, useFirebaseAuth, getCurrentUser } from 'vuefire'

import viewerView from "/views/ViewerView.vue";
import dashboardView from "/views/DashboardView.vue";
import profileView from "/views/ProfileView.vue";

//const user = useCurrentUser()

const routes = [
    {
        path: "/",
        name: "login",
        component: LoginView,
    },
    {
        path: "/dashboard",
        name: "dashboard",
        component: dashboardView,
        meta: {
            authRequired: true,
        },
    },
    {
        path: "/createproject/",
        name: "createproject",
        component: CreateProject,
        meta: {
            authRequired: true,
        },
    },
    {
        path: "/profile",
        name: "profile",
        component: profileView,
        meta: {
            authRequired: true,
        },
    },
    {
        path: "/viewer/:projectName",
        name: "viewer",
        component: viewerView,
        meta: {
            authRequired: true,
        },
    },
];

const router = createRouter({
    //history: createWebHistory(import.meta.env.BASE_URL),
    mode: "history",
    history: createWebHistory(),
    routes,
});

router.beforeEach( async (to, from, next) => {
    const auth = getAuth();
    const currentUser = await getCurrentUser()
    if (to.matched.some((record) => record.meta.authRequired)) {
        if (auth.currentUser) {
            if (to.name === "viewer" && !to.params.projectName) {
                router.push("/dashboard");
                next();
            }
            else {
                next();
            }
        } else {
            alert("You need to be logged in to access this area");
            router.push("/");
            next();
        }
    } else {
        if (to.name === "login" && auth.currentUser) {
            router.push("/dashboard");
        }
        else {
            next();
        }
    }
});

export default router;
